import { z } from "zod";
import { NEWS } from "./consts";

export const schema = z.object({
  [NEWS]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
